import { number, object } from 'yup';

import { validateYupTextField } from '../validateList';

export const farmlandValidationSchema = object().shape({
  farmland_name: validateYupTextField.required('fillField'),
  farmland_type: number().required('fillField'),
});
